'use client';

import { useState } from 'react';
import logWebHeaderHovered from '@alltrails/amplitude/events/logWebHeaderHovered';
import DropdownMenu from '@alltrails/denali/components/DropdownMenu';
import Dropdown from '@alltrails/denali/components/Dropdown';
import { getHeaderLinkOnClickWithAnalytics, HeaderSection } from './headerLinks';
import styles from './styles/styles.module.scss';
import { HeaderBackground } from './types';
import useHeaderLinks, { GetLinkInteractivity } from './useHeaderLinks';

type DropdownProps = {
  background: HeaderBackground;
  index: number;
  getLinkInteractivity: GetLinkInteractivity;
  section: HeaderSection;
};

const DropdownComponent = ({ background, index, getLinkInteractivity, section }: DropdownProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const openDropdown = () => {
    logWebHeaderHovered({ web_header_position: index, web_header_section: section.webHeaderSection });
    setIsOpen(true);
  };

  const toggleDropdown = () => {
    if (!isOpen) {
      logWebHeaderHovered({ web_header_position: index, web_header_section: section.webHeaderSection });
    }
    setIsOpen(!isOpen);
  };

  const anchor = (
    <Dropdown
      className={background === 'transparent-inverted' ? styles.dropdownInverted : styles.dropdown}
      text={section.label}
      variant="flat"
      size="sm"
      onClick={toggleDropdown}
      aria-expanded={isOpen}
      aria-haspopup="menu"
    />
  );
  return (
    <DropdownMenu
      anchor={anchor}
      className={styles.dropdownMenu}
      containerMouseHandlers={{ onMouseEnter: openDropdown, onMouseLeave: () => setIsOpen(false) }}
      isOpen={isOpen}
      onCloseRequest={() => setIsOpen(false)}
      options={section.links.map((link, linkIndex) => {
        const { linkInfo, onClick } = getLinkInteractivity(link);
        const onClickWithAnalytics = getHeaderLinkOnClickWithAnalytics(linkIndex, link.webHeaderDropDownLink, section.webHeaderSection, () => {
          setIsOpen(false);
          onClick?.();
        });
        return {
          className: link.className,
          leadingIcon: link.leadingIcon,
          linkInfo,
          onClick: onClickWithAnalytics,
          title: link.title,
          trailingIcon: link.trailingIcon
        };
      })}
      placement="bottom-end"
      testId={`${section.testId}-dropdown`}
    />
  );
};

type DropdownsProps = {
  background: HeaderBackground;
};

const Dropdowns = ({ background }: DropdownsProps) => {
  const { headerLinks, getLinkInteractivity, signUpModal } = useHeaderLinks();

  return (
    <>
      <div className={styles.dropdowns}>
        {headerLinks.map((section, index) => {
          return (
            <DropdownComponent
              key={section.testId}
              background={background}
              index={index}
              getLinkInteractivity={getLinkInteractivity}
              section={section}
            />
          );
        })}
      </div>
      {signUpModal}
    </>
  );
};

export default Dropdowns;
